import type {
  SubscriptionOfferType,
  SubscriptionResponse,
} from "~/generated/graphql";

interface useFilterOfferByTypeProps {
  offersList: Array<SubscriptionResponse>;
  subscriptionOfferType: SubscriptionOfferType;
}

export const useFilterOfferByType = ({
  offersList,
  subscriptionOfferType,
}: useFilterOfferByTypeProps): SubscriptionResponse | undefined => {
  if (offersList && !!offersList.length) {
    return offersList.find((offer) => offer.type === subscriptionOfferType);
  } else return undefined;
};
